import Builder from '../Builder/Section.js';
export var TopHeaderWrap = Builder({
  className: 'top-header__wrap'
});
export var TopHeader = Builder({
  tagName: 'section',
  className: 'top-header'
});